import React from 'react';
import { useDispatch } from 'react-redux';
import { signIn } from '../../store/actions/auth';
import { Button, Form, Input, notification } from 'antd';
import { APP_TITLE } from '../../constants';
import background from '../../assets/img/undraw_profile_data_re_v81r.svg';
import { LockOpenIcon } from '@heroicons/react/outline';

const LoginScreen = () => {
  const dispatch = useDispatch();

  const handleLogin = async (user) => {
    try {
      const res = await dispatch(signIn(user));

      notification.open({
        type: 'success',
        message: res.message,
        placement: 'bottomRight',
      });
    } catch (error) {
      console.log(error);
      notification.open({
        type: 'error',
        message: error.message,
        placement: 'bottomRight',
      });
    }
  };

  return (
    <div className="h-screen w-full sm:bg-gray-100 flex justify-center items-center">
      <div className="bg-white w-full sm:w-8/12 md:w-6/12 lg:w-4/12 xl:w-3/12 p-10 sm:rounded-md sm:shadow-lg">
        <div className="flex flex-col items-center text-center space-y-4">
          <img src={background} className="h-28" />
          <h1 className="text-3xl text-center font-bold text-cyan-600">
            {APP_TITLE}
          </h1>
        </div>

        <p className="mt-5 mb-4 text-xs">
          Por favor ingrese su usuario y contraseña
        </p>
        <Form onFinish={handleLogin}>
          <Form.Item
            name="username"
            rules={[
              { required: true, message: 'Por favor ingrese su usuario' },
            ]}
          >
            <Input placeholder="Usuario" />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[
              { required: true, message: 'Por favor ingrese su contraseña' },
            ]}
          >
            <Input.Password placeholder="Password" />
          </Form.Item>

          <Form.Item>
            <Button
              htmlType="submit"
              className="w-full bg-cyan-500 text-white justify-center font-bold flex items-center gap-2"
            >
              Iniciar Sesión <LockOpenIcon width={20} />
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default LoginScreen;
